import { createContext } from "react"

export const ViewportContext = createContext({ viewportReady: false })
